export default {
    API_ENDPOINT: 'https://serene-ridge-50508.herokuapp.com/api/expenses',
    TOKEN_KEY: 'API_TOKEN',
}